import mobile from "../common/mobile-input"
import organization from "../config/organization";

const new_page = organization.edit_page ? organization.edit_page + '/new' : false;
const edit_page = organization.edit_page ? organization.edit_page + '/edit/:id' : false;
const edit_template = organization.edit_template ? organization.edit_template : 'edit';

export default [
    {
        path: '/',
        name: '',
        icon: 'el-icon-tickets',
        component: () => import('../views/' + mobile() + 'home.vue'),
        hidden: true,
        children: [
            {path: "", redirect: organization.home_page},
            {
                path: '/edit/:id',
                component: () => import('../views/' + mobile() + edit_template ),
                name: '修改会议',
                redirect: edit_page,
            },
            {
                path: '/edit/:id/recurrent',
                component: () => import('../views/' + mobile() + 'edit'),
                name: '修改循环会议'
            },
            {
                path: '/poll-edit/:id',
                icon: 'el-icon-reading',
                component: () => import('../views/' + mobile() + 'poll-edit'),
                name: '编辑投票',
            },
        ]
    },
    {
        path: '/jwb',
        name: '',
        icon: 'el-icon-tickets',
        hidden: true,
        component: () => import('../views/' + (mobile() ? 'jwb/jwb.vue' : 'home')),
        children: [
            {
                path: 'new',
                component: () => import('../views/jwb/' + (mobile() ? '' : 'web-') + 'edit'),
                name: 'jwb新建会议',
                meta: {nickname: '新建会议'}
            },
            {
                path: 'edit/:id',
                component: () => import('../views/jwb/' + (mobile() ? '' : 'web-') + 'edit'),
                name: 'jwb修改会议',
                meta: {nickname: '修改会议'}
            },
            {
                path: 'meetings',
                component: () => import('../views/jwb/meetings.vue'),
                name: 'jwb会议列表',
                meta: {nickname: '会议列表'}
            },
        ]
    },
    {
        path: '/',
        name: '',
        icon: 'el-icon-tickets',
        meta: {mobile: true},
        component: () => import('../views/' + mobile() + 'home.vue'),
        children: [
            {
                path: '/profile',
                component: () => import('../views/' + mobile() + 'profile'),
                name: '我的档案'
            }
        ]
    },
    {
        path: '/',
        name: '我的会议',
        icon: 'el-icon-guide',
        component: () => import('../views/' + mobile() + 'home.vue'),
        children: [
            {
                path: '/new',
                icon: 'el-icon-plus',
                component: () => import('../views/' + mobile() + edit_template ),
                name: '新建会议',
                meta: {wide: true, forbidden: true},
                redirect: new_page,
            },
            {
                path: '/calendar',
                icon: 'el-icon-date',
                component: () => import('../views/' + mobile() + 'calendar'),
                name: '会议日历',
                meta: {friendly: '日历'}
            },

            {
                path: '/my-course',
                icon: 'el-icon-reading',
                component: () => import('../views/' + mobile() + 'my-course'),
                name: '课程列表',
                meta: {friendly: '课程',hidden: !organization.course}
            },
            {
                path: '/my-meeting',
                icon: 'el-icon-tickets',
                component: () => import('../views/' + mobile() + 'my-meeting'),
                name: '会议列表',
                meta: {friendly: '会议'}
            },
            {
                path: '/questionnaire',
                icon: 'el-icon-document',
                component: () => import('../views/' + mobile() + 'questionnaire'),
                name: '调查问卷',
                meta: {friendly: '问卷'}
            },
        ]
    },
    {
        path: '/',
        name: '通讯录',
        icon: 'el-icon-notebook-2',
        component: () => import('../views/' + mobile() + 'home.vue'),
        meta: {},
        hidden: organization.use_label,
        children: [
            {
                path: '/address-book',
                icon: 'el-icon-user',
                component: () => import('../views/' + mobile() + 'admin-address'),
                name: '联系人',
                meta: {friendly: '联系人', model: 'Contact'}
            },
            {
                path: '/address-group',
                icon: 'el-icon-user-solid',
                component: () => import('../views/' + mobile() + 'admin-group'),
                name: '通讯组',
                meta: {friendly: '联系组', model: 'Group'}
            },
        ]
    },
    {
        path: '/',
        name: '',
        icon: 'el-icon-plus',
        component: () => import('../views/' + mobile() + 'home.vue'),
        meta: {level: [4, 3]},
        hidden:organization.hidden('代建会议'),
        children: [
            {
                path: '/create',
                component: () => import('../views/' + mobile() + 'create'),
                name: '代建会议'
            }
        ]
    },
    {
        path: '/',
        name: '会议查看',
        icon: 'el-icon-view',
        component: () => import('../views/' + mobile() + 'home.vue'),
        meta: {level: [4, 3]},
        children: [
            {
                path: '/meeting-list',
                icon: 'el-icon-s-order',
                component: () => import('../views/' + mobile() + 'meeting-list'),
                name: '查看会议',
                meta: {friendly: '会议', level: [4, 3]}
            },
            {
                path: '/meeting-dayview',
                icon: 'el-icon-price-tag',
                component: () => import( '../views/' + mobile() + 'meeting-dayview.vue'),
                name: '会议日视图',
                meta: {wide: true}
            },
            {
                path: '/meeting-weekview',
                icon: 'el-icon-discount',
                component: () => import( '../views/' + mobile() + 'meeting-weekview.vue'),
                name: '会议周视图',
                meta: {wide: true}
            },
            {
                path: '/meeting-monthview',
                icon: 'el-icon-date',
                component: () => import('../views/meeting-monthview.vue'),
                name: '会议月视图',
                meta: {wide: true}
            },
        ]
    },
    {
        path: '/',
        name: '审批',
        icon: 'el-icon-edit-outline',
        component: () => import( '../views/' + mobile() + 'home.vue'),
        meta: {level: [4, 3]},
        children: [
            {
                icon: 'el-icon-s-grid',
                path: '/approve',
                component: () => import( '../views/' + mobile() + 'approve'),
                name: '审批会议',
                meta: {friendly: '用户', model: 'Approve'}
            },
            {
                icon: 'el-icon-user-solid',
                path: '/approve-user',
                component: () => import( '../views/' + mobile() + 'approve'),
                name: '审批用户',
                meta: {friendly: '用户', model: 'User.Approve'}
            },
            {
                icon: 'el-icon-lock',
                path: '/admin/lock',
                component: () => import('../views/' + mobile() + 'admin-lock'),
                name: '会议控制',
                meta: {friendly: '会议', model: 'Lock', copy: false, level: [4]}
            },
        ],
    },
    {
        path: '/admin',
        name: '后台管理',
        icon: 'el-icon-setting',
        component: () => import( '../views/' + mobile() + 'home.vue'),
        meta: {level: [4], wide: true},
        children: [
            {
                icon: 'el-icon-cpu',
                path: '/admin/delay',
                component: () => import( '../views/admin-delay'),
                name: '延长时间',
                meta: {friendly: '延长', 'model': 'Delay'}
            },
            {
                icon: 'el-icon-user',
                path: '/visitor',
                component: () => import( '../views/admin-visitors'),
                name: '用户管理',
                meta: {friendly: '用户', model: 'Visitor'}
            },
            {
                icon: 'el-icon-aim',
                path: '/position',
                component: () => import( '../views/admin-admin'),
                name: '用户类型',
                meta: {
                    friendly: '类型', model: 'PositionCode', copy: true,
                    hidden: organization.hidden('用户类型')
                }
            },
            {
                icon: 'el-icon-star-on',
                path: '/tm-user',
                component: () => import('../views/' + mobile() + 'admin-tm-user'),
                name: '腾讯用户',
                meta: {friendly: '用户', model: 'TMRoom'}
            },
            {
                icon: 'el-icon-s-flag',
                path: '/department-privilege',
                component: () => import( '../views/admin-admin'),
                name: '会议组权限',
                meta: {friendly: '会议组权限', model: 'DepartmentPrivilege', copy: true}
            },
            {
                icon: 'el-icon-document',
                path: '/admin/survey',
                component: () => import( '../views/admin-admin'),
                name: '调查问题',
                meta: {friendly: '调查问题', 'model': 'Survey', copy: true}
            },
            {
                icon: 'el-icon-message-solid',
                path: '/admin/announcement',
                component: () => import( '../views/admin-admin'),
                name: '公告管理',
                meta: {friendly: '公告', 'model': 'Announcement', copy: true}
            },
            {
                icon: 'el-icon-postcard',
                path: '/admin/disclaimer',
                component: () => import('../views/admin-disclaimer'),
                name: '声明管理',
                meta: {friendly: '声明', 'model': 'Disclaimer'}
            },
            {
                icon: 'el-icon-basketball',
                path: '/admin/batch',
                component: () => import('../views/import-meetings'),
                name: '批量建会',
            },
            {
                icon: 'el-icon-video-camera',
                path: '/admin/video-analysis',
                component: () => import('../views/admin-video-analysis'),
                name: '视频分析',
                meta: {friendly: '视频分析', hidden: !organization.show_video_analysis}
            },
            {
                icon: 'el-icon-key',
                path: '/admin/client-token',
                component: () => import('../views/admin-client-token'),
                name: '接口凭证',
                meta: {friendly: '接口凭证', 'model': 'ClientToken', hidden: !organization.show_open_api}
            },

        ]
    },
    {
        path: '/system',
        name: '系统管理',
        icon: 'el-icon-set-up',
        component: () => import('../views/' + mobile() + 'home.vue'),
        meta: {level: [4], wide: true},
        children: [
            {
                icon: 'el-icon-s-release',
                path: '/room',
                component: () => import('../views/admin-rooms'),
                name: '会议室管理',
                meta: {
                    friendly: '会议室', model: 'ZoomRoom', copy: true,
                    hidden: organization.hidden('会议室管理')
                }
            },
            {
                icon: 'el-icon-s-release',
                path: '/room-group',
                component: () => import('../views/admin-admin'),
                name: '会议室组管理',
                meta: {friendly: '会议室组', model: 'RoomGroup', copy: true,
                    hidden: organization.hidden('会议室组管理')}
            },
            {
                icon: 'el-icon-discount',
                path: '/admin-tm-room',
                component: () => import('../views/' + mobile() + 'admin-tm-room'),
                name: '会议室',
                meta: {friendly: '日志', model: 'TencentRoom', edit: false,
                    hidden: organization.hidden('会议室')}
            },
            {
                icon: 'el-icon-coffee-cup',
                path: '/room-tm-room-meeting',
                component: () => import('../views/admin-admin'),
                name: '会议室会议',
                meta: {friendly: '会议室会议', model: 'TmRoomsMeeting', copy: false,
                    delete: true, add: false ,
                    hidden: organization.hidden('会议室会议')}
            },
            {
                icon: 'el-icon-s-operation',
                path: '/parameters',
                component: () => import('../views/admin-admin'),
                name: '参数管理',
                meta: {friendly: '参数', model: 'Parameter', copy: true}
            },
            {
                icon: 'el-icon-present',
                path: '/admin-scheduler',
                component: () => import('../views/' + mobile() + 'admin-scheduler'),
                name: '调度日志',
                meta: {friendly: '日志', model: 'Scheduler',}
            },
            {
                icon: 'el-icon-key',
                path: '/admin-syslog',
                component: () => import('../views/admin-syslog'),
                name: '系统日志',
                meta: {friendly: '日志', model: 'Syslog',}
            },
            {
                icon: 'el-icon-postcard',
                path: '/admin/mail-template',
                component: () => import('../views/admin-mailtemplate'),
                name: '邮件模板',
                meta: {friendly: '邮件模板', 'model': 'MailTemplate'}
            },
            {
                icon: 'el-icon-picture-outline-round',
                path: '/background-upload',
                component: () => import('../views/' + mobile() + 'admin-admin'),
                name: '背景图片',
                meta: {friendly: '图片', model: 'BackgroundPicture',
                    hidden: organization.hidden('背景图片')}
            },
            {
                icon: 'el-icon-ice-cream-square',
                path: '/manual-upload',
                component: () => import('../views/' + mobile() + 'admin-admin'),
                name: '用户手册上传',
                meta: {friendly: '手册', model: 'Manual'}
            },
            {
                icon: 'el-icon-school',
                path: '/admin/university',
                component: () => import('../views/admin-admin'),
                name: '学院管理',
                meta: {friendly: '学院', model: 'University',
                    hidden: organization.hidden('学院管理')
                },
            },
        ]
    },
    {
        path: '/report',
        name: organization.menu_report_name,
        icon: 'el-icon-data-line',
        component: () => import('../views/' + mobile() + 'home.vue'),
        meta: {wide: true},
        children: [
            {
                path: '/meeting-detail',
                component: () => import('../views/meeting-detail.vue'),
                name: '会议详情'
            },
            {
                path: '/meeting-participant',
                component: () => import('../views/admin-admin.vue'),
                name: '参会者',
                meta: {level: [4], model: 'MeetingParticipant'}
            },
            {
                path: '/static',
                component: () => import('../views/statistic.vue'),
                name: '使用统计'
            },
            {
                path: '/answers',
                component: () => import('../views/answers.vue'),
                name: '调查统计',
                meta: {level: [4]}
            },

        ],
    },
    {
        path: '/',
        name: '',
        icon: 'el-icon-tickets',
        meta: {mobile: true},
        component: () => import('../views/' + mobile() + 'home.vue'),
        children: [
            {
                path: '/manual',
                component: () => import('../views/' + mobile() + 'manual'),
                name: '用户手册'
            }
        ]
    },

]
